// Oferta formativa institucional: programas y capacitaciones que Arcus imparte
// a organizaciones. A diferencia de los cursos, no se venden en línea: cada una
// se cotiza a partir de una solicitud de propuesta.

export type OfferingCategory = "PROGRAMA" | "CAPACITACION";

export const OFFERING_CATEGORY_LABELS: Record<OfferingCategory, string> = {
  PROGRAMA: "Programa",
  CAPACITACION: "Capacitación",
};

/** Rótulo de la lista de temas: cambia según la categoría */
export const OFFERING_FOCUS_LABELS: Record<OfferingCategory, string> = {
  PROGRAMA: "Áreas clave",
  CAPACITACION: "Enfoque",
};

/** Texto del botón de solicitud, distinto en cada categoría */
export const OFFERING_CTA_LABELS: Record<OfferingCategory, string> = {
  PROGRAMA: "Solicitar propuesta",
  CAPACITACION: "Solicitar capacitación",
};

export interface TrainingOffering {
  id: string;
  slug: string;
  category: OfferingCategory;
  title: string;
  summary: string;
  /** "Áreas clave" en programas, "Enfoque" en capacitaciones */
  focusAreas: string[];
  /** Texto libre porque son rangos: "16 a 24 horas" */
  durationLabel: string;
  modalities: string[];
  coverImageUrl: string | null;
  isPublished: boolean;
  position: number;
  createdAt: Date;
  updatedAt: Date;
}
